import React from 'react';
import { Icon } from '../../elements/icon';

const ReassuranceBadge = ({ text }) => {
  if (!text) return null;

  return (
    <div className="t-mt-[5px] t-py-[7px] t-px-2.5 t-rounded-lg t-bg-quiz-teal/[.05] t-text-[11.5px] t-leading-relaxed t-text-quiz-teal t-flex t-items-start t-gap-[7px] t-animate-[fadeUp_.2s]">
      <Icon name="shieldCheck" size={14} raw className="t-flex-shrink-0 t-mt-1" />
      <span>{text}</span>
    </div>
  );
};

export default ReassuranceBadge;
